import {
  Box,
  Button,
  Card,
  CardContent,
  Checkbox,
  FormControlLabel,
  IconButton,
  Paper,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import { Add, Delete, Save } from "@mui/icons-material";
import { useEffect, useState } from "react";
import { getAvailability, saveAvailability } from "../common/api";
import { useTranslation } from "react-i18next";
import Notifier from "../common/Notifier";

const UpdateSchedule = () => {
  const [doctors, setDoctors] = useState([]);
  const [isHoliday, setIsHoliday] = useState(false);
  const { t } = useTranslation();

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    const data = await getAvailability();
    if (data) {
      setDoctors(data.doctors || []);
      setIsHoliday(data.isHoliday || false);
    }
  };

  const formatTimeForInput = (timestamp) => {
    if (!timestamp) return "18:00";
    const date = new Date(timestamp);
    return `${date.getHours().toString().padStart(2, "0")}:${date.getMinutes().toString().padStart(2, "0")}`;
  };

  const parseTimeToTimestamp = (timeStr) => {
    const [hours, minutes] = timeStr.split(":").map(Number);
    const date = new Date();
    date.setHours(hours, minutes, 0, 0);
    return date.getTime();
  };

  const onChangeScheduleTime = (doctorIndex, scheduleIndex, field, value) => {
    const updated = [...doctors];
    updated[doctorIndex].schedule[scheduleIndex][field] = parseTimeToTimestamp(value);
    setDoctors(updated);
  };

  const addScheduleSlot = (doctorIndex) => {
    const updated = [...doctors];
    updated[doctorIndex].schedule.push({
      startTime: parseTimeToTimestamp("18:00"),
      endTime: parseTimeToTimestamp("21:00"),
    });
    setDoctors(updated);
  };

  const removeScheduleSlot = (doctorIndex, scheduleIndex) => {
    const updated = [...doctors];
    updated[doctorIndex].schedule.splice(scheduleIndex, 1);
    setDoctors(updated);
  };

  const onClickSave = async () => {
    const success = await saveAvailability({ doctors, isHoliday });
    Notifier.notify("snackbar", {
      content: success ? "Schedule updated successfully" : "Error updating schedule",
    });
  };

  return (
    <div>
      <Paper elevation={0} sx={{ padding: "0 0 12px 0" }}>
        {doctors.map((doctor, doctorIndex) => (
          <Card variant="outlined" key={doctorIndex}>
            <CardContent>
              <Typography variant="h5" gutterBottom>
                {doctor.name}
              </Typography>
              <Typography variant="body2" color="text.secondary" gutterBottom>
                {doctor.degree}
              </Typography>

              {doctor.schedule?.map((slot, scheduleIndex) => (
                <Stack
                  key={scheduleIndex}
                  direction="row"
                  spacing={2}
                  mt={2}
                  alignItems="center"
                >
                  <TextField
                    type="time"
                    label="Start"
                    size="small"
                    value={formatTimeForInput(slot.startTime)}
                    onChange={(e) =>
                      onChangeScheduleTime(doctorIndex, scheduleIndex, "startTime", e.target.value)
                    }
                    InputLabelProps={{ shrink: true }}
                  />
                  <TextField
                    type="time"
                    label="End"
                    size="small"
                    value={formatTimeForInput(slot.endTime)}
                    onChange={(e) =>
                      onChangeScheduleTime(doctorIndex, scheduleIndex, "endTime", e.target.value)
                    }
                    InputLabelProps={{ shrink: true }}
                  />
                  <IconButton
                    color="error"
                    onClick={() => removeScheduleSlot(doctorIndex, scheduleIndex)}
                    size="small"
                  >
                    <Delete />
                  </IconButton>
                </Stack>
              ))}

              <Button
                startIcon={<Add />}
                size="small"
                color="primary"
                onClick={() => addScheduleSlot(doctorIndex)}
                sx={{ mt: 2 }}
              >
                Add Slot
              </Button>
            </CardContent>
          </Card>
        ))}

        <Box m={2}>
          <FormControlLabel
            control={
              <Checkbox
                checked={isHoliday}
                color="primary"
                onChange={(e) => setIsHoliday(e.target.checked)}
              />
            }
            label={t("holiday")}
          />
        </Box>

        <Box m={2}>
          <Button
            color="primary"
            variant="contained"
            onClick={onClickSave}
            startIcon={<Save />}
            fullWidth
          >
            Save
          </Button>
        </Box>
      </Paper>
    </div>
  );
};

export default UpdateSchedule;
